import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';

export interface IAuthContextProps {
	user: string;
	setUser?(user: string): void;
	userData: any;
}
const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;
}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [user, setUser] = useState<string>(localStorage.getItem('user') || '');
	const [userData, setUserData] = useState<any>({});

	useEffect(() => {
		localStorage.setItem('user', user);
	}, [user]);

	useEffect(() => {
		if (user !== '') {
			fetchUserData(user);
		} else {
			setUserData({});
		}
	}, [user]);

	const serverUrl = process.env.server_url;

	const fetchUserData = async (username: string) => {
		const response = await fetch(`${serverUrl}/api/users/${username}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${localStorage.getItem('token')}`
			}
		});
		if (response.ok) {
			const data = await response.json();
			setUserData(data);
		}
	};

	const value = useMemo(
		() => ({
			user,
			setUser,
			userData,
		}),
		[user, userData],
	);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
